import { create } from 'zustand';
import { ApiUtils, FileApi, FileTypeEntity, RequestStrategyEnum } from '@shared/api';

interface IFileTypesStore {
  loading: boolean;
  error: string | null;
  fileTypes: FileTypeEntity[];
  getFileTypes: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useFileTypesStore = create<IFileTypesStore>((set) => ({
  loading: false,
  error: null,
  fileTypes: [],

  getFileTypes: ApiUtils.wrapperApi(async (signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await FileApi.getFileTypes(signal);
      set({ fileTypes: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ fileTypes: [], loading: false, error: null }),
}));
